import loadable from '@loadable/component';

export const LazyPageNotFound = loadable(() => import(/* webpackChunkName: "content/pagenotfound-ssr" */ '.'));
